import React from 'react';
import ReactDOM from 'react-dom';
import Header from './components/Header';
import VideoFormContainer from './components/VideoFormContainer';
import Footer from './components/Footer';
import LogoAgentContainer from './components/LogoAgentContainer';
import RelatedVideos from './components/RelatedVideos';
import Modal from './components/Modal';
import StickyRightButton from './components/StickyRightButton';

const DEV_CONFIG = {
    USE_LOCAL_MOCK: false,
    DEFAULT_MOCK_FILE: "json/galaxy.json"
};

const DEFAULT_PAGE_STYLES = {
    "headerStyle": { "backgroundColor": "#495FA6", "color": "#FFF" },
    "footerStyle": { "backgroundColor": "#495FA6", "color": "#FFF" },
    "caption-title": { "backgroundColor": "#495FA6", "color": "#FFF" },
    "header-bar": { "borderTop": "8px solid #749BDB" },
    "sidebar": { "backgroundColor": "#749BDB", "color": "#FFF" },
    "triagle1": { "borderRightColor": " #6C9DED" },
    "triagle2": { "borderLeftColor": "#5284D5" },
    "btn-primary": {
        "backgroundColor": "#3498db",
        "hoverBg": "#0c86d8"
    },
    "submit-btn": {
        "backgroundColor": "#3498db",
        "hoverBg": "#0c86d8"
    },
    "btn": [{ "focus": { "backgroundColor": "#0c86d8" } },
    { "active": { "focus": { "backgroundColor": "#0c86d8" } } }],
    "btn.active": { "focus": { "backgroundColor": "#0c86d8" } }
};

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPageLoading: true,
            hasPageLoadError: false,
            vidkey: "",
            videoFkey: "",
            vehicleFkey: "",
            shareUrl: "",
            header: "",
            dealerName: "",
            dealerNameMissing: "",
            disclaimer: "",
            dealer: "",
            logo: "",
            agent: "",
            video: "",
            form: "",
            footer: "",
            templateId: "",
            templateName: "",
            selectedThemeId: "",
            videoCall: "",
            pageStyles: DEFAULT_PAGE_STYLES,
            preview: false,
            showShortDesc: false,
            trackingCode: "",
            GATrackingId:"",
            videoOrientation:"",
            isPlayerPortrait: false,
            viPlayer:"",
            baseUrl: this.getBaseUrl(),
            //baseUrl : window.location.protocol+"//"+window.location.hostname,
            lpUrl: "/LP/index_json.php",
            lpEndUrl: "&RUN_TYPE=LP_FULL_PAGE_JSON",
            rvEndUrl: "&RUN_TYPE=LP_RELATED_VIDEOS_JSON",
            backgroundImageVal: '',
            siteCss:'',
            pageParams:this.pageParams(),
        };
        this.loadRelatedVideo = this.loadRelatedVideo.bind(this);
        this.handleVideoOrientation = this.handleVideoOrientation.bind(this);
        this.loadData = this.loadData.bind(this);
        this.switchTheme = this.switchTheme.bind(this);
        this.getQueryStringValue = this.getQueryStringValue.bind(this);
        this.switchTheme = this.switchTheme.bind(this);
        this.changeTheme = this.changeTheme.bind(this);
        this.handleExpandText = this.handleExpandText.bind(this);
        this.appendGAScript = this.appendGAScript.bind(this);
        this.loadMetaData = this.loadMetaData.bind(this);
        this.getBaseUrl = this.getBaseUrl.bind(this);
        this.detectIosDevice = this.detectIosDevice.bind(this);
        this.sendHeightToIframeParent = this.sendHeightToIframeParent.bind(this);
        this.isVtPlayer = this.isVtPlayer.bind(this);
        this.pageParams = this.pageParams.bind(this);
        this.closePopupModal = this.closePopupModal.bind(this);
    }

    handleVideoOrientation(reportedOrientation) {
        const isPlayerPortrait = reportedOrientation === 'P';
        if (isPlayerPortrait !== this.state.isPlayerPortrait) {
            this.setState({ isPlayerPortrait });
        }
    }

    getBaseUrl() {
        const baseDiv = document.getElementById('BASE_URL_DIV');
        const baseUrl = baseDiv ? baseDiv.getAttribute('data-baseUrl') : '';
        if (!baseUrl) {
            return window.location.protocol + '//' + window.location.hostname;
        }
        const urls = baseUrl.split(':');
        if (window.location.protocol === 'http:') {
            return (window.location.protocol + urls[0]).replace(/\/+$/, '');
        } else if (window.location.protocol === 'https:') {
            return (window.location.protocol + baseUrl).replace(/\/+$/, '');
        }
        return baseUrl.replace(/\/+$/, '');
    }

    pageParams() {
        const pageLocationUrl = new URL(document.location.href);
        const pageParams = new URLSearchParams(pageLocationUrl.search);
        const isModalEmbed = pageParams.get("modal_embed") === "1";
        if(isModalEmbed){
            const closeBtn = document.createElement('div');
            closeBtn.classList.add('close-btn');
            closeBtn.style.display = 'none';
            closeBtn.innerHTML = "&#x2715;";
            closeBtn.addEventListener('click', this.closePopupModal);
            document.querySelector('#app').appendChild(closeBtn);
            document.body.classList.add('modal-embed');
            closeBtn.style.display = 'block';
        }
    }

    closePopupModal() {
        window.parent.postMessage({ action: 'close_modal[con]!' }, '*');
    }

    detectIosDevice() {
        return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    }

    isVtPlayer() {
        const tId = this.state && this.state.templateId;
        if (tId === "VT_VIDEO_RV" || tId === "VT_VIDEO_FORM" || tId === "VT_VIDEO_FORM_RV") {
            return true;
        }
        if (tId && typeof tId === "string" && tId.startsWith("VT_")) {
            return true;
        }
        const domainId = this.getQueryStringValue("template_domain_id") || this.getQueryStringValue("domainId");
        if (domainId === "232" || domainId === "234" || domainId === "235") {
            return true;
        }
        if (typeof document !== "undefined" && document.body && document.body.classList.contains("vt-template")) {
            return true;
        }
        return false;
    }

    sendHeightToIframeParent() {
        if (this.isVtPlayer()) {
            var vtElem = document.querySelector('#main-widget-areaplayer') ||
                         document.querySelector('.vt-container') ||
                         document.querySelector('.vt-main-section') ||
                         document.querySelector('#app') ||
                         document.body;

            var getHeight = vtElem ? (vtElem.offsetHeight || vtElem.scrollHeight) : (document.body ? (document.body.offsetHeight || document.body.scrollHeight) : 0);
            var getWidth = vtElem ? (vtElem.offsetWidth || vtElem.scrollWidth) : (document.body ? (document.body.offsetWidth || document.body.scrollWidth) : 0);

            if (getHeight > 0 && getWidth > 0) {
                var currAspectRatio = (getWidth / getHeight).toFixed(2);

                window.parent.postMessage(JSON.stringify({ body_height: (getHeight), height: (getHeight), aspectRatio: currAspectRatio, 'action': 'playerTabsFile' }), "*");

                setTimeout(() => {
                    var updatedElem = document.querySelector('#main-widget-areaplayer') ||
                                      document.querySelector('.vt-container') ||
                                      document.querySelector('.vt-main-section') ||
                                      document.querySelector('#app') ||
                                      document.body;
                    var newH = updatedElem ? (updatedElem.offsetHeight || updatedElem.scrollHeight) : getHeight;
                    var newW = updatedElem ? (updatedElem.offsetWidth || updatedElem.scrollWidth) : getWidth;
                    var newRatio = (newH > 0 && newW > 0) ? (newW / newH).toFixed(2) : currAspectRatio;

                    window.parent.postMessage(JSON.stringify({ body_height: (newH), height: (newH), aspectRatio: newRatio, 'action': 'playerTabsFile' }), "*");
                }, 500);
            }
            return;
        }

        window.parent.postMessage(JSON.stringify({ height: document.body.scrollHeight }), "*");
    }


    loadRelatedVideo(relatedVideo, event) {
        event.preventDefault();
        if (this.state.preview) {
            return false;
        }
        // console.log("relatedVideo.main_title", relatedVideo.main_title);
        let video = {
            title: relatedVideo.main_title,
            description: relatedVideo.description,
            meta_description: relatedVideo.meta_description,
            source: relatedVideo.source,
            poster: relatedVideo.poster,
            video_fk: relatedVideo.video_fk,
            vin: relatedVideo.vin,
            stock: relatedVideo.stock,
            tabbed_player: relatedVideo.tabbed_player,
            isPlayerPano: relatedVideo["360_player"],
            video_orientation: relatedVideo['video_orientation'] || relatedVideo['videoOrientation'] || '',
            videoOrientation: relatedVideo['video_orientation'] || relatedVideo['videoOrientation'] || '',
            viPlayer: relatedVideo['vi_player']
            // main_title: relatedVideo.main_title

        }

        this.setState({
            video: video,
            isPlayerPortrait: false,
            videoOrientation: video.video_orientation || video.videoOrientation || ''
        }, function () {
            this.loadMetaData(video.title, video.poster, this.state.dealerName, video.meta_description);
            if (this.isVtPlayer()) {
                this.sendHeightToIframeParent();
            }
        });

    }

    componentWillMount() {
        //  if(this.detectIosDevice()) document.body.classList.add("ios-device");
        const that = this;
        this.loadData();
        let domainId = this.getQueryStringValue("template_domain_id");

        if (domainId.length > 0) {
            this.setState({ preview: true }, function () {
                (function () {
                    var theBody = document.getElementsByTagName('body')[0];
                    var currentHeight = theBody.offsetHeight;
                    var sendPostMessageUpdate = function () {
                        if (that.isVtPlayer()) {
                            that.sendHeightToIframeParent();
                        } else {
                            window.parent.postMessage(JSON.stringify({ height: (theBody.offsetHeight + 1) }), "*");
                        }
                        currentHeight = theBody.offsetHeight;
                        // console.log('currentHeight', currentHeight);
                    }
                    setInterval(function () {
                        // If the content height has changed, send a postMessage
                        var vtElem = document.querySelector('#main-widget-areaplayer') || document.querySelector('.vt-container');
                        var checkHeight = that.isVtPlayer() ? (vtElem ? vtElem.offsetHeight : theBody.offsetHeight) : theBody.offsetHeight;
                        if (currentHeight !== checkHeight) {
                            sendPostMessageUpdate();
                        }
                    }, 100);
                    // Initial resize postMessage
                    sendPostMessageUpdate();
                })();
            });
        }

        function getBodyWidth() {
            let bd = document.querySelector("body").offsetWidth;
            that.setState({ bodyWidth: bd });
        }

        getBodyWidth();
        const self = this;

        window.onorientationchange = function () {
            //console.log("orientation changed");
            self.sendHeightToIframeParent();
            setTimeout(self.sendHeightToIframeParent, 500);
            setTimeout(self.sendHeightToIframeParent, 1000);
            setTimeout(self.sendHeightToIframeParent, 2000);
        }

        window.onresize = function () {
            //console.log("window resized");
            getBodyWidth();
            self.sendHeightToIframeParent();
            setTimeout(self.sendHeightToIframeParent, 500);
            setTimeout(self.sendHeightToIframeParent, 1000);
            setTimeout(self.sendHeightToIframeParent, 2000);
        }
        // document.addEventListener('touchstart', {});
        this.sendHeightToIframeParent();
        setTimeout(this.sendHeightToIframeParent, 500);
        setTimeout(this.sendHeightToIframeParent, 1000);
        setTimeout(this.sendHeightToIframeParent, 2000);
        setTimeout(this.sendHeightToIframeParent, 3000);
        setTimeout(this.sendHeightToIframeParent, 5000);
        setTimeout(this.sendHeightToIframeParent, 7000);

    }

    componentDidMount() {
        this.sendHeightToIframeParent();
        setTimeout(this.sendHeightToIframeParent, 500);
        setTimeout(this.sendHeightToIframeParent, 1000);
        setTimeout(this.sendHeightToIframeParent, 2000);

        if (!this.vtIntervalStarted) {
            this.vtIntervalStarted = true;
            let lastVtHeight = 0;
            setInterval(() => {
                if (this.isVtPlayer()) {
                    let vtElem = document.querySelector('#main-widget-areaplayer') || document.querySelector('.vt-container') || document.querySelector('.vt-main-section');
                    let h = vtElem ? vtElem.offsetHeight : 0;
                    if (h > 0 && h !== lastVtHeight) {
                        lastVtHeight = h;
                        this.sendHeightToIframeParent();
                    }
                }
            }, 100);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.templateId !== this.state.templateId || prevState.video !== this.state.video) {
            this.sendHeightToIframeParent();
            setTimeout(this.sendHeightToIframeParent, 500);
        }
    }

    getQueryStringValue(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }

    switchTheme(event) {
        let btn = event.target;
        let selectedThemeId = btn.previousElementSibling.value;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {

            }
        };

        let url = this.state.baseUrl + "/ava/admin/index.php?APP_TYPE=CLIENTS&RUN_TYPE=SAVE_EMAIL_THEME&video_fk=&type=&theme=" + selectedThemeId + "&domainId=" + this.state.templateId + "&page_type=LP"
        xhttp.open("GET", url, true);
        xhttp.send();
    }

    changeTheme(event) {
        let selectedThemeId = event.target.value;
        let colors;
        for (let i = 0; i < this.state.themes.length; i++) {
            if (this.state.themes[i].theme_id === selectedThemeId) {
                colors = JSON.parse(this.state.themes[i].theme_style_colors);
            }
        }
        this.setState({ pageStyles: colors }, function () {

        });
    }

    handleExpandText(event) {
        let expandLink = event.target;
        event.preventDefault();
        if (event.target.textContent === "Show more") {
            this.setState({ showShortDesc: true });
            expandLink.style.display = "none";
            expandLink.nextSibling.style.display = "block";
            expandLink.nextSibling.style.transition = "0.3s";
        } else {
            this.setState({ showShortDesc: false });
            expandLink.style.display = "none";
            expandLink.previousSibling.style.display = "block";
            expandLink.previousSibling.style.transition = "0.3s";
        }
    }

    closeModal(el) {
        el.style.display = "none";
    }

    appendGAScript(scriptCode) {
        if (typeof scriptCode !== 'string' || !scriptCode.trim()) {
            return false;
        }
        if (/^(?:UA-\d+-\d+|G-[A-Z0-9]+|GTM-[A-Z0-9]+|AW-\d+)$/i.test(scriptCode.trim())) {
            return false;
        }

        const scriptLocation = document.head;

        // let docBody = document.getElementsByTagName('body')[0];
        scriptCode = scriptCode.replace("<script>", "");
        scriptCode = scriptCode.replace("</script>", "");
        scriptCode = scriptCode.replace("<!-- Google Analytics -->", "");
        scriptCode = scriptCode.replace("<!-- End Google Analytics -->", "");
        scriptCode = scriptCode.trim(scriptCode);
        let scriptObj = document.createElement("SCRIPT");
        scriptObj.type = 'text/javascript';
        scriptObj.textContent = scriptCode;
        scriptLocation.appendChild(scriptObj);
    }

    loadMetaData(title, image, siteName, desc) {
        title = title || "";
        image = image || "";
        siteName = siteName || "";
        desc = desc || "";

        let ogTitle = document.querySelector('[property="og:title"]');
        let ogImage = document.querySelector('[property="og:image"]');
        let ogSiteName = document.querySelector('[property="og:site_name"]');
        let ogDesc = document.querySelector('[property="og:description"]');

        // ogTitle.setAttribute("content", title);
        // ogImage.setAttribute("content", image);
        // ogSiteName.setAttribute("content", siteName);
        // ogDesc.setAttribute("content", desc);
    }

    loadData() {
        this.setState({ isPageLoading: true, hasPageLoadError: false });
        // console.log('baseurl', this.state.baseUrl);
        const baseUrl = this.state.baseUrl;
        let lpUrl = this.state.lpUrl;
        let urlParmas = window.location.search;
        let endUrl = this.state.lpEndUrl;
        let pageData = null;
        const xhttp = new XMLHttpRequest();
        const that = this;

        const urlParamsObj = new URLSearchParams(window.location.search);
        const mockParam = urlParamsObj.get("mock");
        const domainIdParam = urlParamsObj.get("template_domain_id") || urlParamsObj.get("domainId");
        const isReactDevServer = window.location.port === "3000";
        const isMock = isReactDevServer || mockParam !== null || DEV_CONFIG.USE_LOCAL_MOCK;

        function reportPageLoadError() {
            that.setState({ isPageLoading: false, hasPageLoadError: true });
        }

        xhttp.onerror = reportPageLoadError;
        xhttp.ontimeout = reportPageLoadError;
        xhttp.timeout = 30000;
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status !== 200) {
                reportPageLoadError();
                return;
            }
            if (this.readyState === 4 && this.status === 200) {
                try {
                    pageData = JSON.parse(this.responseText);
                    if (!pageData || typeof pageData !== 'object' || Array.isArray(pageData)) {
                        reportPageLoadError();
                        return;
                    }
                    // console.log('JSON.parse(pageData["page_style"])',JSON.parse(pageData["page_style"]).themeImage);
                    if (pageData["lp_internal_name"] === "SOCIALIZE" ||
                        pageData["lp_internal_name"] === "SOCIALIZE_FOOTER" || pageData['show_no_vid']) {
                        pageData["page_style"] = JSON.stringify({
                            "headerStyle": { "backgroundColor": "#495FA6", "color": "#FFF" },
                            "footerStyle": { "backgroundColor": "#495FA6", "color": "#FFF" },
                            "caption-title": { "backgroundColor": "#495FA6", "color": "#FFF" },
                            "header-bar": { "borderTop": "8px solid #749BDB" },
                            "sidebar": { "backgroundColor": "#749BDB", "color": "#FFF" },
                            "triagle1": { "borderRightColor": " #6C9DED" },
                            "triagle2": { "borderLeftColor": "#5284D5" },
                            "btn-primary": {
                                "backgroundColor": "#3498db",
                                "hoverBg": "#0c86d8"
                            },
                            "submit-btn": {
                                "backgroundColor": "#3498db",
                                "hoverBg": "#0c86d8"
                            },
                            "btn": [{ "focus": { "backgroundColor": "#0c86d8" } },
                            { "active": { "focus": { "backgroundColor": "#0c86d8" } } }],
                            "btn.active": { "focus": { "backgroundColor": "#0c86d8" } }
                        });
                    }
                } catch (error) {
                    console.log(error);
                    reportPageLoadError();
                    return;
                }

                let currentTemplateId = pageData["lp_internal_name"];
                if (!currentTemplateId || currentTemplateId === "THEATER_FOOTER") {
                    if (domainIdParam === "235") {
                        currentTemplateId = "VT_VIDEO_FORM_RV";
                    } else if (domainIdParam === "232") {
                        currentTemplateId = "VT_VIDEO_RV";
                    } else if (domainIdParam === "234") {
                        currentTemplateId = "VT_VIDEO_FORM";
                    }
                }

                const hasPageTemplate = typeof currentTemplateId === 'string' && currentTemplateId.length > 0;
                if (!hasPageTemplate && !pageData.show_no_vid) {
                    reportPageLoadError();
                    return;
                }

                if (hasPageTemplate && currentTemplateId.startsWith("VT_")) {
                    document.body.classList.add("vt-template");
                } else {
                    document.body.classList.remove("vt-template");
                }

                let parsedPageStyle = null;
                try {
                    if (typeof pageData["page_style"] === "string" && pageData["page_style"].trim()) {
                        parsedPageStyle = JSON.parse(pageData["page_style"]);
                    } else if (typeof pageData["page_style"] === "object" && pageData["page_style"]) {
                        parsedPageStyle = pageData["page_style"];
                    }
                } catch (e) {
                    parsedPageStyle = null;
                }

                if (!parsedPageStyle || typeof parsedPageStyle !== "object") {
                    parsedPageStyle = DEFAULT_PAGE_STYLES;
                } else {
                    parsedPageStyle = Object.assign({}, DEFAULT_PAGE_STYLES, parsedPageStyle);
                }

                that.setState({
                    isPageLoading: false,
                    hasPageLoadError: false,
                    isPlayerPortrait: false,
                    vidkey: pageData["email_guid"],
                    videoFkey: pageData["video_fkey"],
                    vehicleFkey: pageData["vehicle_fkey"],
                    shareUrl: pageData["share_url"],
                    templateId: currentTemplateId,
                    templateName: pageData["lp_template_name"],
                    selectedThemeId: pageData['lp_selected_theme_id'],
                    dealerName: pageData["dealer-name"],
                    dealerEmail: pageData["dealer-email"],
                    dealerNameMissing: pageData["dealer-name_missing"],
                    dealer: pageData['dealer'],
                    header: pageData['header'],
                    logo: pageData["logo-src"],
                    agent: pageData['agent'],
                    video: pageData["video"],
                    form: pageData['form'],
                    lpForm: pageData['lp_form'],
                    footer: pageData["footer"],
                    videoCall: pageData["video_call"],
                    pageStyles: parsedPageStyle,
                    themes: pageData["theme_rows"],
                    trackingCode: pageData["template_tracking_code"],
                    GATrackingId: pageData["cs_guaid"] ? pageData["cs_guaid"] : '',
                    show_no_vid: pageData["show_no_vid"],
                    disclaimer: pageData["template_disclaimer"],
                    backgroundImageVal: (parsedPageStyle && parsedPageStyle.themeImage) ? parsedPageStyle.themeImage : '',
                    siteCss: (parsedPageStyle && parsedPageStyle.siteCss) ? parsedPageStyle.siteCss : '',
                    videoOrientation: (pageData["video"] && (pageData["video"].video_orientation || pageData["video"].videoOrientation)) ? (pageData["video"].video_orientation || pageData["video"].videoOrientation) : '',
                    viPlayer: (pageData["video"] && (pageData["video"].vi_player || pageData["video"].viPlayer)) ? (pageData["video"].vi_player || pageData["video"].viPlayer) : ''
                    
                    // player_pano     : this.state.video.isPlayerPano
                }, function () {                    
                    //  console.log("dealerName", this.state.dealerName);
                    this.appendGAScript(this.state.trackingCode);
                    
                    if (typeof this.state.video !== "undefined" && this.state.video) {
                        this.loadMetaData(this.state.video.title, this.state.video.poster, this.state.dealerName, this.state.video.meta_description);
                    }
                    this.sendHeightToIframeParent();
                    setTimeout(this.sendHeightToIframeParent, 500);
                    setTimeout(this.sendHeightToIframeParent, 1000);
                });
            }
        };

        let requestUrl;
        if (isMock) {
            let mockName;
            if (mockParam && mockParam !== "1" && mockParam !== "true") {
                mockName = mockParam;
            } else if (domainIdParam === "235") {
                mockName = "vt_video_form_rv";
            } else if (domainIdParam === "232") {
                mockName = "vt_video_rv";
            } else if (domainIdParam === "234") {
                mockName = "vt_video_form";
            } else {
                mockName = DEV_CONFIG.DEFAULT_MOCK_FILE;
            }
            if (!mockName.endsWith(".json")) {
                mockName += ".json";
            }
            requestUrl = mockName.startsWith("json/") ? mockName : `json/${mockName}`;
        } else {
            requestUrl = baseUrl + lpUrl + urlParmas + endUrl;
        }

        xhttp.open("GET", requestUrl, true);
        xhttp.send();
    }

    render() {
        if (this.state.isPageLoading || this.state.hasPageLoadError) {
            return null;
        }

        let finalRender;

        if (typeof this.state.templateId === "undefined") {
            finalRender = null;
        } else {
            let themeStyle = document.createElement("style");
            themeStyle.innerText = this.state.siteCss;
            document.head.appendChild(themeStyle);

            let themeBg = {
                // "backgroundImage": "url(" + this.state.baseUrl + "/NLP/public/images/" + this.state.backgroundImageVal.backgroundImage + ")",
                "color": this.state.backgroundImageVal.color,
            }

            if (this.state.templateId === "VT_VIDEO_RV" ||
                this.state.templateId === "VT_VIDEO_FORM" ||
                this.state.templateId === "VT_VIDEO_FORM_RV") {

                finalRender = <div className="theme vt-theme" style={themeBg}>
                    <Modal
                        shareurl={this.state.shareUrl}
                        lpForm={this.state.lpForm} />
                    <VideoFormContainer
                        handleExpandText={this.handleExpandText}
                        showShortDesc={this.state.showShortDesc}
                        lpForm={this.state.lpForm}
                        template={this.state.templateId}
                        links={this.state.header.headerLinks}
                        styles={this.state.pageStyles}
                        video={this.state.video}
                        form={this.state.form}
                        shareurl={this.state.shareUrl}
                        agent={this.state.agent}
                        dealerName={this.state.dealerName}
                        preview={this.state.preview}
                        bodyWidth={this.state.bodyWidth}
                        disclaimer={this.state.disclaimer}
                        playerPano={this.state.player_pano}
                        GATrackingId={this.state.GATrackingId}
                        videoOrientation={this.state.videoOrientation}
                        viPlayer={this.state.viPlayer}
                        baseUrl={this.state.baseUrl}
                        vidkey={this.state.vidkey}
                        vehicleFkey={this.state.vehicleFkey}
                        handleLoadVideo={this.loadRelatedVideo}
                        backgroundImageVal={this.state.backgroundImageVal}
                        isPlayerPortrait={this.state.isPlayerPortrait}
                        reportVideoOrientation={this.handleVideoOrientation}
                    />
                </div>
            } else if (this.state.templateId === "THEATER_CONTACT_FOOTER" ||
                this.state.templateId === "THEATER_FOOTER" ||
                this.state.templateId === "CROSSBAR_FOOTER" ||
                this.state.templateId === "CROSSBAR_LEFT_FOOTER" ||
                this.state.templateId === "LINKED_UP_FOOTER" ||
                this.state.templateId === "SOCIALIZE_FOOTER" ||
                this.state.templateId === "GET_STARTED_FOOTER" ||
                this.state.templateId === "LINKED_UP_LEFT_FOOTER" ||
                this.state.templateId === "NEWSLETTER_FOOTER" ||
                this.state.templateId === "TABBED_THEATER_FOOTER" || 
                this.state.templateId === "LP_LINKS_WITH_ICONS") {

                finalRender = <div className="theme" style={themeBg}>
                    <Modal
                        shareurl={this.state.shareUrl}
                        lpForm={this.state.lpForm} />
                    <Header
                        preview={this.state.preview}
                        themes={this.state.themes}
                        switchTheme={this.switchTheme}
                        selectedThemeId={this.state.selectedThemeId}
                        changeTheme={this.changeTheme}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        dealer={this.state.dealer}
                        styles={this.state.pageStyles}
                        dealerName={this.state.dealerName}
                        dealernamemissing={this.state.dealerNameMissing}
                        toplinks={this.state.header.headerLinks} />

                    <VideoFormContainer
                        handleExpandText={this.handleExpandText}
                        showShortDesc={this.state.showShortDesc}
                        lpForm={this.state.lpForm}
                        template={this.state.templateId}
                        links={this.state.header.headerLinks}
                        styles={this.state.pageStyles}
                        video={this.state.video}
                        form={this.state.form}
                        shareurl={this.state.shareUrl}
                        agent={this.state.agent}
                        dealerName={this.state.dealerName}
                        preview={this.state.preview}
                        bodyWidth={this.state.bodyWidth}
                        disclaimer={this.state.disclaimer}
                        playerPano={this.state.player_pano}
                        GATrackingId={this.state.GATrackingId}
                        videoOrientation={this.state.videoOrientation}
                        viPlayer={this.state.viPlayer}
                    />

                    <RelatedVideos
                        baseurl={this.state.baseUrl}
                        preview={this.state.preview}
                        handleLoadVideo={this.loadRelatedVideo}
                        template={this.state.templateId}
                        videos={this.state.relatedVideos}
                        vidkey={this.state.vidkey}
                        video_fk={this.state.video.video_fk}
                        vehicleFkey={this.state.vehicleFkey}
                        backgroundImageVal={this.state.backgroundImageVal}
                        viPlayer={this.state.viPlayer}
                    />

                    <Footer
                        template={this.state.templateId}
                        styles={this.state.pageStyles}
                        footer={this.state.footer} />

                    <LogoAgentContainer
                        styles={this.state.pageStyles}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        logo={this.state.logo}
                        agent={this.state.agent}
                        video_fk={this.state.video.video_fk}
                        dealerName={this.state.dealerName}
                        dealerEmail={this.state.dealerEmail}
                        backgroundImageVal={this.state.backgroundImageVal}
                        preview={this.state.preview} 
                        dealerUrl={this.state.dealer.dealer_url}/>

                    <StickyRightButton
                        videoCall={this.state.videoCall} />
                </div>
            } else {
                finalRender = <div className="theme" style={themeBg}>
                    <Modal
                        shareurl={this.state.shareUrl}
                        lpForm={this.state.lpForm} />

                    <Header
                        preview={this.state.preview}
                        themes={this.state.themes}
                        switchTheme={this.switchTheme}
                        selectedThemeId={this.state.selectedThemeId}
                        changeTheme={this.changeTheme}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        dealer={this.state.dealer}
                        styles={this.state.pageStyles}
                        dealerName={this.state.dealerName}
                        dealernamemissing={this.state.dealerNameMissing}
                        toplinks={this.state.header.headerLinks} />

                    <LogoAgentContainer
                        styles={this.state.pageStyles}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        logo={this.state.logo}
                        agent={this.state.agent}
                        video_fk={this.state.video.video_fk}
                        dealerName={this.state.dealerName}
                        dealerEmail={this.state.dealerEmail}
                        backgroundImageVal={this.state.backgroundImageVal}
                        preview={this.state.preview} 
                        dealerUrl={this.state.dealer.dealer_url}/>

                    <VideoFormContainer
                        handleExpandText={this.handleExpandText}
                        showShortDesc={this.state.showShortDesc}
                        lpForm={this.state.lpForm}
                        agent={this.state.agent}
                        template={this.state.templateId}
                        links={this.state.header.headerLinks}
                        styles={this.state.pageStyles}
                        video={this.state.video}
                        form={this.state.form}
                        shareurl={this.state.shareUrl}
                        dealerName={this.state.dealerName}
                        preview={this.state.preview}
                        bodyWidth={this.state.bodyWidth}
                        disclaimer={this.state.disclaimer}
                        playerPano={this.state.player_pano}
                        themes={this.state.themes}
                        selectedThemeId={this.state.selectedThemeId}
                        GATrackingId={this.state.GATrackingId}
                        videoOrientation={this.state.videoOrientation}
                        viPlayer={this.state.viPlayer}
                    />

                    <RelatedVideos
                        baseurl={this.state.baseUrl}
                        handleLoadVideo={this.loadRelatedVideo}
                        videos={this.state.relatedVideos}
                        vidkey={this.state.vidkey}
                        video_fk={this.state.video.video_fk}
                        vehicleFkey={this.state.vehicleFkey}
                        preview={this.state.preview}
                        themes={this.state.themes}
                        switchTheme={this.switchTheme}
                        selectedThemeId={this.state.selectedThemeId}
                        changeTheme={this.changeTheme}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        dealer={this.state.dealer}
                        styles={this.state.pageStyles}
                        dealerName={this.state.dealerName}
                        dealernamemissing={this.state.dealerNameMissing}
                        toplinks={this.state.header.headerLinks}
                        lpForm={this.state.lpForm}
                        backgroundImageVal={this.state.backgroundImageVal}
                        viPlayer={this.state.viPlayer}
                    />

                    <Footer
                        template={this.state.templateId}
                        styles={this.state.pageStyles}
                        footer={this.state.footer} />

                    <StickyRightButton
                        videoCall={this.state.videoCall} />
                </div>
            }
        }

        if (this.state.show_no_vid) {
            finalRender = <div><img src={this.state.show_no_vid} alt="..." /></div>;
        }

        return (finalRender);
    };
}

ReactDOM.render(
    <App />, document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js